import {
  AbstractSpinConfig,
  PlaySoundAction,
  ReelsEngine,
  ReelsSoundModel,
  StopSoundAction,
  WaitForAction,
  CollapsingSpinConfig,
  FastSpinsComponent,
  FAST_SPINS_COMPONENT,
} from '@cgs/machines';
import { BuildAction } from '@cgs/shared';
import {
  Container,
  EmptyAction,
  FunctionAction,
  IntervalAction,
  ParallelAction,
  SequenceAction,
  Vector2,
} from '@cgs/wge';

export class SantaFreeFallSpinAction extends BuildAction {
  private readonly _container: Container;
  private readonly _reelsEngine: ReelsEngine;
  private readonly _spinConfig: AbstractSpinConfig;
  private readonly _collapsingSpinConfig: CollapsingSpinConfig;
  private readonly _reelSounds: ReelsSoundModel;
  private readonly fastSpinsComponent: FastSpinsComponent;
  private _reelsDelay: number[];

  constructor(
    container: Container,
    reelsEngine: ReelsEngine,
    spinConfig: AbstractSpinConfig,
    reelSounds: ReelsSoundModel,
    collapsingSpinConfig: CollapsingSpinConfig
  ) {
    super();
    this._container = container;
    this._reelsEngine = reelsEngine;
    this._spinConfig = spinConfig;
    this._reelSounds = reelSounds;
    this._collapsingSpinConfig = collapsingSpinConfig;

    this.fastSpinsComponent = container.resolve<FastSpinsComponent>(FAST_SPINS_COMPONENT);
  }

  public buildAction(): IntervalAction {
    const actions: IntervalAction[] = [];
    this._reelsDelay = this.fastSpinsComponent.isFastSpinsActive
      ? new Array(this._reelsEngine.ReelConfig.reelCount).fill(0)
      : this._collapsingSpinConfig.collapsingParameters!.fallSpinDelays;

    const outgoingSound = this._reelSounds.getSoundByName('reels_spin');

    actions.push(new StopSoundAction(outgoingSound));
    actions.push(new PlaySoundAction(outgoingSound));

    for (let reel = 0; reel < this._reelsEngine.ReelConfig.reelCount; ++reel) {
      actions.push(this._spin(reel));
    }
    actions.push(new WaitForAction(this._reelsEngine.slotsAccelerated));
    return new ParallelAction(actions);
  }

  private _spin(reel: number): IntervalAction {
    const actions: IntervalAction[] = [];

    const duration = this.fastSpinsComponent.isFastSpinsActive
      ? this._spinConfig.accelerationDuration * 4
      : this._spinConfig.accelerationDuration;

    for (let line = this._reelsEngine.ReelConfig.lineCount - 1; line >= 0; --line) {
      actions.push(
        new FunctionAction(() =>
          this._reelsEngine.accelerateEntity(
            reel,
            line,
            Vector2.Zero,
            new Vector2(0.0, this._spinConfig.spinSpeed),
            duration
          )
        )
      );
      actions.push(new EmptyAction().withDuration(line * 0.01));
    }

    return new SequenceAction(actions);
  }
}
